(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const section = document.querySelector('[data-sale-primary-colors]');
  if (!section) return;
  const colorName = 'filter.v.option.color';
  const families = new Map([
    ['gid://shopify/FilterSettingGroup/213811486', 'BLUE'],
    ['gid://shopify/FilterSettingGroup/213844254', 'BLUE'],
    ['gid://shopify/FilterSettingGroup/213877022', 'BLUE'],
    ['gid://shopify/FilterSettingGroup/213909790', 'BLUE'],
    ['gid://shopify/FilterSettingGroup/52723998', 'ORANGE'],
    ['Coral', 'ORANGE'],
    ['gid://shopify/FilterSettingGroup/52789534', 'PURPLE'],
    ['Orchid', 'PURPLE']
  ]);
  const familyFor = input => families.get(input.value) || input.value;
  const inputsIn = root => [...root.querySelectorAll('input[name="filter.v.option.color"]')];
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  let queued = false;
  const refresh = () => {
    queued = false;
    section.querySelectorAll('[data-filter-form]').forEach(form => {
      const groups = new Map();
      inputsIn(form).forEach(input => {
        const family = familyFor(input);
        if (!families.has(input.value)) return;
        if (!groups.has(family)) groups.set(family, []);
        groups.get(family).push(input);
      });
      groups.forEach((inputs, family) => {
        inputs.forEach((input, index) => {
          input.closest('li').classList.toggle('sale-color-family-hidden', index > 0);
          if (index > 0) return;
          input.dataset.saleColorFamily = family;
          const label = input.closest('label');
          setText(label.querySelector('.filter-item__label'), family);
          const count = label.querySelector('.filter-item__count');
          if (count) count.classList.add('sale-color-family-hidden');
          input.checked = inputs.some(member => member.checked);
          input.disabled = inputs.every(member => member.disabled);
          label.classList.toggle('filter-item__content--disabled', input.disabled);
        });
      });
      const selected = new Set([...form.querySelectorAll('input[type="checkbox"]:checked')].map(input => input.name + ':' + familyFor(input)));
      form.querySelectorAll('[data-active-filter-count],.filter-drawer__title-count').forEach(node => setText(node, String(selected.size)));
      const colorSelected = [...new Set(inputsIn(form).filter(input => input.checked).map(input => families.get(input.value) || input.closest('label').querySelector('.filter-item__label')?.textContent.trim() || input.value))];
      const group = inputsIn(form)[0]?.closest('[data-filter-group],.filter-drawer__group');
      group?.querySelectorAll('[data-group-active-count]').forEach(node => setText(node, String(colorSelected.length)));
      if (colorSelected.length) group?.querySelectorAll('.filter-group__values-active-values').forEach(node => setText(node, colorSelected.join(', ')));
    });
    section.querySelectorAll('[data-active-filters]').forEach(container => {
      const seen = new Set();
      container.querySelectorAll('[data-remove-filter]').forEach(link => {
        if (link.dataset.name !== colorName || !families.has(link.dataset.value)) return;
        const family = families.get(link.dataset.value);
        link.classList.toggle('sale-color-family-hidden', seen.has(family));
        seen.add(family);
        link.dataset.saleColorFamily = family;
        [...link.childNodes].filter(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()).forEach(node => { if (node.textContent.trim() !== family) node.textContent = family; });
      });
    });
  };
  section.addEventListener('change', event => {
    const input = event.target;
    if (input.name !== colorName || !input.dataset.saleColorFamily) return;
    const family = input.dataset.saleColorFamily;
    inputsIn(input.closest('form')).forEach(member => {
      if (families.get(member.value) === family) member.checked = input.checked;
    });
  }, true);
  section.addEventListener('click', event => {
    const link = event.target.closest('[data-remove-filter][data-sale-color-family]');
    if (!link) return;
    inputsIn(section).forEach(input => {
      if (families.get(input.value) === link.dataset.saleColorFamily) input.checked = false;
    });
  }, true);
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(refresh); }
  });
  observer.observe(section, {childList: true, subtree: true});
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turtleson-brand-story"] && !Shopify.designMode) return;
  try {
    

(()=>{
 const init=(root)=>{
  if(root.dataset.tbsReady)return;
  root.dataset.tbsReady='true';
  const header=document.querySelector('.header__outer-wrapper');
  if(header){const syncHeader=()=>root.style.setProperty('--tbs-header-height',header.getBoundingClientRect().height+'px');syncHeader();if('ResizeObserver' in window)new ResizeObserver(syncHeader).observe(header)}
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce&&'IntersectionObserver' in window){
   root.classList.add('tbs-motion');
   const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('tbs-pending');reveal.unobserve(entry.target)}}),{threshold:.07});
   root.querySelectorAll('[data-tbs-reveal]').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('tbs-pending');reveal.observe(el)}});
  }
  root.querySelectorAll('[data-stitch-gallery]').forEach(gallery=>{
   const track=gallery.querySelector('[data-stitch-track]'),slides=Array.from(track.children),prev=gallery.querySelector('[data-stitch-prev]'),next=gallery.querySelector('[data-stitch-next]'),count=gallery.querySelector('[data-stitch-count]');
   if(!slides.length)return;
   let current=0,timer;
   const update=()=>{current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));prev.disabled=current===0;next.disabled=current===slides.length-1;count.textContent=(current+1)+' / '+slides.length};
   const move=delta=>{current=Math.max(0,Math.min(slides.length-1,current+delta));track.scrollTo({left:current*track.clientWidth,behavior:reduce?'instant':'smooth'})};
   prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(update,120)},{passive:true});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}});
   if('ResizeObserver' in window)new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'});update()}).observe(track);
   update();
  });
  root.querySelectorAll('[data-logic-chapter]').forEach(chapter=>chapter.addEventListener('toggle',()=>{
   if(!chapter.open)return;
   root.querySelectorAll('[data-logic-chapter]').forEach(other=>{if(other!==chapter)other.open=false});
   root.querySelectorAll('[data-logic-image]').forEach(img=>img.classList.toggle('is-active',img.dataset.logicImage===chapter.dataset.logicChapter));
  }));
  root.querySelectorAll('.tbs-nav a,.tbs-hero a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
   const target=document.getElementById(link.hash.slice(1));if(!target)return;
   event.preventDefault();target.scrollIntoView({behavior:reduce?'instant':'smooth',block:'start'});
   history.replaceState(null,'',link.hash);
  }));
  if('IntersectionObserver' in window){
   const nav=root.querySelector('.tbs-nav');
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)nav.querySelectorAll('a').forEach(a=>{const active=a.hash==='#'+entry.target.id;a.classList.toggle('is-active',active);if(active)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')})}),{rootMargin:'-15% 0px -60% 0px'});
   nav.querySelectorAll('a').forEach(a=>{const target=document.getElementById(a.hash.slice(1));if(target)observer.observe(target)});
  }
 };
 document.querySelectorAll('[data-tbs]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-tbs]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turtleson-fit-guide"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('turtleson-fit-guide')) {
  customElements.define('turtleson-fit-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[data-audience]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectAudience(tab.dataset.audience));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') target = (index + 1) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.tabs[target].focus();
          this.selectAudience(this.tabs[target].dataset.audience);
        });
      });
      this.querySelectorAll('[data-switch-women]').forEach(button => button.addEventListener('click', () => {
        this.selectAudience('women');
        this.tabs[1].focus({ preventScroll: true });
        this.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }));
    }
    selectAudience(audience) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.audience === audience;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.panel !== audience;
        if (!panel.hidden && !this.reducedMotion) panel.animate([{ opacity: .35, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 260, easing: 'ease-out' });
      });
    }

  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-wl-review-toggle]');
    if(!button)return;
    const expanded=button.getAttribute('aria-expanded')!=='true';
    button.setAttribute('aria-expanded',String(expanded));
    button.closest('.wl-product-reviews').dataset.expanded=String(expanded);
    button.innerHTML=expanded?'Show fewer reviews <span aria-hidden="true">↑</span>':'View more reviews <span aria-hidden="true">↓</span>';
  });

  } catch(e) { console.error(e); }
})();
})();
